<template>
    <div>
        <table class="table table-striped mt-2">
            <tr v-for="(r, index) in value" :key="index">
                <td>{{ r.interval }}</td>
                <td>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="btn btn-dark">{{ currency === "BRL" ? "R$" : "US$" }}</span>
                        </div>
                        
                        <input
                            class="form-control"
                            :value="r.unitValue"
                            type="number"
                            @change="changeValue(index, $event)"
                        />
                    </div>
                </td>
                <td>
                    <button
                        class="btn btn-danger"
                        @click.prevent="remove(index)"
                    >
                        <!-- i18n-validator-ignore-next-line: universal delete symbol -->
                        x
                    </button>
                </td>
            </tr>
            <tr>
                <td>
                    <input
                        class="form-control"
                        type="number"
                        :placeholder="t('plans-form-price_table-interval')"
                        v-model="interval"
                    />
                </td>
                <td>
                    <input
                        class="form-control"
                        type="number"
                        :placeholder="t('plans-form-price_table-unit_value')"
                        v-model="unitValue"
                    />
                </td>
                <td>
                    <button
                        class="btn btn-primary mt-2"
                        @click.prevent="addInterval"
                    >
                        {{ t('plans-form-price_table-add_button') }}
                    </button>
                </td>
            </tr>
        </table>
    </div>
</template>
<style scoped lang="scss">
.input-group {
    margin-top: 0;
}
td {
    vertical-align: middle;
}
</style>
<script>
export default {
    props: {
        value: Array,
        currency: String,
    },
    data: () => ({
        interval: null,
        unitValue: null,
    }),
    methods: {
        formatCurrency: function (v) {
            return v.toLocaleString(this.currency === "USD" ? "en-US" : "pt-BR", {
                style: "currency",
                currency: this.currency || "BRL",
            });
        },
        remove(index) {
            const value = this.value.filter((v, i) => i !== index);
            this.$emit("input", value);
        },
        changeValue(index, event) {
            const newValue = JSON.parse(JSON.stringify(this.value));
            newValue[index].unitValue = event.target.value;
            this.$emit("input", newValue);
        },
        addInterval: function () {
            if (
                this.interval &&
                this.unitValue !== null &&
                this.unitValue !== ""
            ) {
                const value = [
                    ...this.value,
                    { interval: this.interval, unitValue: this.unitValue },
                ].sort((a, b) => a.interval - b.interval);
                this.$emit("input", value);
                this.interval = null;
                this.unitValue = null;
            }
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
